import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PassengersService } from '@app/passengers/passengers.service';
import { MatDialogConfig, MatDialog } from '@angular/material';
import { BlockComponent } from '@app/shared/components/block/block.component';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss']
})
export class DetailsComponent implements OnInit {

  @Input() service;

  allHistory$: Observable<any>; //remove any
  accountingHistory$: Observable<any>; //remove any
  blockingHistory$: Observable<any>; //remove any

  @Output() reload = new EventEmitter();

  showBlock = false;
  dialogRef;
  passenger;

  private reasons = [];

  constructor(private passengersService: PassengersService, public dialog: MatDialog, ) { }

  @Input('passenger') set setPassenger(passenger) {
    if (!passenger) return;
    this.passenger = passenger;
    this.allHistory$ = this.passengersService.getPassengerHistory('history/passenger', { id: this.passenger.id, service: this.service });
    this.accountingHistory$ = this.passengersService.getPassengerHistory('passenger/accounting/bonus/history', { id: this.passenger.id, service: this.service });
    this.blockingHistory$ = this.passengersService.getPassengerHistory('blocking/history/passenger', { id: this.passenger.id, service: this.service });
  };

  ngOnInit() {
    this.passengersService.getPassengersBlockReasons().subscribe(res => this.reasons = res['data']);
  }

  switchBlockForm(status) {
    this.showBlock = status;
  }

  getIcon(type){
    switch (type) {
      case 'action_passenger_block':        
        return 'lock'
        case 'action_passenger_unblock':        
        return 'lock_open'
    }
  }

  closeBlockForm() {
    this.showBlock = false;
  }

  blockPassenger() {

    let config = <MatDialogConfig>{
      position: {
        top: '5%'
      },
      data: {
        'title': 'CLIENT_BLOCK',
        'reasons': this.reasons
      },
      disableClose: true
    };
    this.dialogRef = this.dialog.open(BlockComponent, config);
    this.dialogRef.afterClosed().subscribe((data) => {
      if (data.result) {
        this.passengersService.blockPassengers({
          id: this.passenger.id,
          reason_id: data.reason,
          comment: data.comment
        }).subscribe(res => this.reload.emit())
      }
      this.dialogRef = null;

    });
  }

  unblockPassenger() {
    this.passengersService.unblockPassengers({
      id: this.passenger.id,
      comment: 'will be added later'
    }).subscribe(res => this.reload.emit())
  }

}



// WEBPACK FOOTER //
// ./src/app/passengers/details/details.component.ts